import ThumbnailCardList from './ThumbnailCardList';
import { ThumbnailCardListProps, ThumbnailCardListValueProps } from './types';

export type { ThumbnailCardListProps, ThumbnailCardListValueProps };
export default ThumbnailCardList;
